import { usePostSprint } from '../api/sprint-api/sprint-api';
import { SprintDto } from '../api/model';
import { useQueryClient } from '@tanstack/react-query';

export const usePostSprintCreate = () => {
  const postSprintMutation = usePostSprint();
  const queryClient = useQueryClient();

  const createSprint = async (sprintData: SprintDto & { releaseId?: number }) => {
    try {
      const response = await postSprintMutation.mutateAsync({ data: sprintData });

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['/sprint'] }),
        queryClient.invalidateQueries({ queryKey: ['/project'] }),
        queryClient.invalidateQueries({ queryKey: ['projects'] }),
      ]);

      if (sprintData.releaseId || (response as any)?.release) {
        await queryClient.invalidateQueries({ 
          queryKey: ['/release']
        });
      }
      
      return response;
    } catch (error) {
      // Callers already show a toast on failure; avoid double-notifying
      throw error;
    }
  };

  return {
    createSprint,
    isLoading: postSprintMutation.isPending,
    error: postSprintMutation.error
  };
};